var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    transform: "translate(0.669922)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16992 15.8973C11.1318 15.8973 13.0134 15.118 14.4006 13.7307C15.7879 12.3434 16.5673 10.4619 16.5673 8.5C16.5673 6.5381 15.7879 4.65656 14.4006 3.26929C13.0134 1.88202 11.1318 1.10266 9.16992 1.10266C7.20803 1.10266 5.32648 1.88202 3.93921 3.26929C2.55194 4.65656 1.77258 6.5381 1.77258 8.5C1.77258 10.4619 2.55194 12.3434 3.93921 13.7307C5.32648 15.118 7.20803 15.8973 9.16992 15.8973ZM9.16992 5.726C9.90563 5.726 10.6112 6.01826 11.1314 6.53848C11.6517 7.05871 11.9439 7.76429 11.9439 8.5C11.9439 9.23571 11.6517 9.94129 11.1314 10.4615C10.6112 10.9817 9.90563 11.274 9.16992 11.274C8.43421 11.274 7.72863 10.9817 7.20841 10.4615C6.68818 9.94129 6.39592 9.23571 6.39592 8.5C6.39592 7.76429 6.68818 7.05871 7.20841 6.53848C7.72863 6.01826 8.43421 5.726 9.16992 5.726Z",
    fill: "#0D6E89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioQuestion);
export default __webpack_public_path__ + "static/media/radio-question.1d6d09306936f8eec2867754783dcdfd.svg";
export { ForwardRef as ReactComponent };